import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const END = new Date("2026-08-22T00:00:00+09:00");
const IMG = "/imid-2026-booth-21.jpg";
const LINK = "/research-highlights/imid-2026-booth-21.html";
const BOOK = "https://cal.com/yogeshgawale";

const T = {
  en: { kicker: "We are exhibiting", name: "IMID 2026 - Booth 21", meta: "August 18 to 21, 2026 - BEXCO, Busan, Korea", book: "Book a meeting slot", view: "View details" },
  ko: { kicker: "전시 참가", name: "IMID 2026 - 부스 21", meta: "2026년 8월 18일 ~ 21일 - 부산 벡스코", book: "미팅 예약하기", view: "자세히 보기" },
  zh: { kicker: "我们参展", name: "IMID 2026 - 展位 21", meta: "2026年8月18日至21日 - 韩国釜山 BEXCO", book: "预约会面", view: "查看详情" },
  de: { kicker: "Wir stellen aus", name: "IMID 2026 - Stand 21", meta: "18. bis 21. August 2026 - BEXCO, Busan", book: "Termin buchen", view: "Details ansehen" },
};

const CSS = [
  "@keyframes lamkoSlideIn{0%{opacity:0;transform:translateX(-70px)}60%{opacity:1}100%{opacity:1;transform:translateX(0)}}",
  ".lamko-eh{padding:104px 20px 34px;background:linear-gradient(180deg,#0b1220 0%,#111a2e 100%);border-bottom:1px solid #1f2a44}",
  ".lamko-eh-in{max-width:1120px;margin:0 auto;display:flex;gap:26px;align-items:center;flex-wrap:wrap;justify-content:center}",
  ".lamko-eh-anim{animation:lamkoSlideIn .95s cubic-bezier(.16,1,.3,1) both}",
  ".lamko-eh-img{flex:1 1 440px;max-width:640px;display:block}",
  ".lamko-eh-img img{width:100%;height:auto;display:block;border-radius:12px;box-shadow:0 14px 38px rgba(0,0,0,.5)}",
  ".lamko-eh-txt{flex:1 1 300px;max-width:420px;color:#e5e7eb}",
  ".lamko-eh-btn{display:inline-block;background:linear-gradient(90deg,#ea580c,#f59e0b);color:#fff;font-weight:700;padding:12px 24px;border-radius:9px;text-decoration:none;font-size:15px;transition:transform .18s ease,box-shadow .18s ease}",
  ".lamko-eh-btn:hover{transform:translateY(-2px);box-shadow:0 10px 24px rgba(234,88,12,.4)}",
  ".lamko-eh-ghost{display:inline-block;color:#fdba74;font-weight:600;padding:12px 20px;border-radius:9px;text-decoration:none;font-size:15px;border:1px solid #fdba74;transition:background .18s ease}",
  ".lamko-eh-ghost:hover{background:rgba(253,186,116,.12)}",
  "@media (max-width:900px){.lamko-eh{padding:92px 18px 28px}.lamko-eh-in{gap:18px}.lamko-eh-txt{text-align:center}}",
  "@media (prefers-reduced-motion:reduce){.lamko-eh-anim{animation:none}}",
].join("");

export const EventHero = () => {
  const { i18n } = useTranslation();
  const [go, setGo] = useState(false);
  useEffect(() => { const t = setTimeout(() => setGo(true), 120); return () => clearTimeout(t); }, []);
  const lang = ((i18n && i18n.language) || "en").slice(0, 2);
  if (new Date() >= END) return null;
  const c = T[lang] || T.en;
  return (
    <section className="lamko-eh">
      <style>{CSS}</style>
      <div className={"lamko-eh-in" + (go ? " lamko-eh-anim" : "")} style={{ opacity: go ? 1 : 0 }}>
        <a className="lamko-eh-img" href={LINK}>
          <img src={IMG} alt="LUMORA at IMID 2026, Booth 21, BEXCO Busan, August 18 to 21, 2026" />
        </a>
        <div className="lamko-eh-txt">
          <div style={{ fontSize: 12, letterSpacing: 2, color: "#fdba74", fontWeight: 700, marginBottom: 8, textTransform: "uppercase" }}>{c.kicker}</div>
          <div style={{ fontSize: 26, fontWeight: 800, color: "#fff", marginBottom: 6, lineHeight: 1.25 }}>{c.name}</div>
          <div style={{ fontSize: 14, color: "#94a3b8", marginBottom: 18 }}>{c.meta}</div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            <a className="lamko-eh-btn" href={BOOK} target="_blank" rel="noopener noreferrer">{c.book}</a>
            <a className="lamko-eh-ghost" href={LINK}>{c.view}</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EventHero;
